module.exports = __webpack_public_path__ + "img/name_bg.c0e47e65.png";